import { Injectable } from '@angular/core';
import {EFrom, Section, Group, Field, Choice, ChoiceLookUp, MultiLang, Column} from '../model/eform-type';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl } from '@angular/forms';
import { EFormHelper } from '../helper/script/helper';
import { NewControls } from '../config/new-controls';
import { ValidatorConfigure } from '../config/validator';
import { TranslateService } from '@ngx-translate/core';
import { Subject, Subscription } from 'rxjs';
import { UUID } from '../helper/script/uuid';
import { EformAPI } from '../e-form.api';
import { LookUpConverter } from '../helper/script/lookupConverter';

@Injectable({
   providedIn: 'root'
})
export class EformService {
   eForm: FormGroup;
   formValue: EFrom;
   helper = new EFormHelper();
   uuid = new UUID();
   newControl: NewControls;
   _subscribeFormName: Subscription;
   validators = new ValidatorConfigure();
   choiceString1: any;
   choiceString2: any;
   choiceString3: any;
   choiceString4: any;
   choiceString5: any;
   isNotCompleteAllSign: boolean = false;
   taskAttributeTemp;
   statusForm: string;
   public colors = [
      '#8b0000',
      '#daa520',
      '#778899',
      '#800080',
      '#ff00ff',
      '#008080',
      '#556b2f',
      '#32cd32',
      '#3EA99F',
      '#0000cd',
      '#ff69b4',
      '#ff0000',
      '#bdb76b',
      '#FFD700',
      '#7FFFD4',
      '#FF4500',
      '#32CD32',
      '#FF8B8B',
      '#9932CC',
      '#A0522D',
      '#00CED1',
      '#2F4F4F',
      '#98AFC7',
      '#566D7E',
      '#FBE7A1',
      '#728FCE',
      '#4863A0',
      '#2B547E',
      '#81D8D0',
      '#2554C7',
      '#1589FF',
      '#00BFFF',
      '#87CEEB',
      '#C6DEFF',
      '#B0E0E6',
      '#16E2F5',
      '#045F5F',
      '#31906E',
      '#50C878',
      '#006400',
      '#32CD32',
      '#DAEE01',
      '#FFFACD',
      '#57FEFF',
      '#FED8B1',
      '#FFFF00',
      '#D9F1F1',
      '#B6E3E9',
      '#D1EAF5',
      '#C3DDE0',
      '#A5CEDB',
      '#95C8D7',
      '#AACCE2',
      '#789CCE',
      '#FBD4AD',
      '#F8D7C1',
      '#EDAB94',
      '#FFAE92',
      '#DADDC5',
      '#A5B89C',
      '#C1D7D0',
      '#CAE3CC',
      '#E0F8E8',
      '#D9EDE7',
      '#BDDED1',
      '#B7B7FF',
      '#E7D2EF',
      '#EFE5EE',
      '#C4B3C3',
      '#C6A5C7',
      '#E2D0DC',
      '#D9B0CD',
      '#DFA5D6',
      '#E5A9DE',
      '#FEF4F3',
      '#FCDEE2',
      '#FFD6DA',
      '#FFC6CF',
      '#FFE4E3',
      '#FFD3D3',
      '#FFCDCD',
      '#FFB7B7',
      '#FBF1D5',
      '#FFE2AE',
      '#F4CC84',
      '#F7D07A'
   ];
   public changeFlowRecipientData = new Subject<any>();
   public changeFlowRecipientTrigger = new Subject<any>();
   public changeSignatureBackground = new Subject<any>();
   public removeGroup = new Subject<any>();


   constructor(private fb: FormBuilder, private translate: TranslateService, private api: EformAPI) {
      this.formValue = new EFrom();
      this.formValue.formName = {en : '', th: '', cn: ''};
      this.formValue.original = this.translate.currentLang;
      this.translate.get('eform.field-properties.radio').subscribe(msg => {
         this.choiceString1 = msg['yes-no'];
         this.choiceString2 = msg['true-false'];
         this.choiceString3 = msg['enable-disable'];
         this.choiceString4 = msg['on-off'];
         this.choiceString5 = msg['read-unread'];
      });
   }

   unInitailization() {
      this.formValue = new EFrom();
      this.newControl = null;
   }

   initailization() {
      this.formValue.original = this.translate.currentLang;
      this.formController();
      this.newControl = new NewControls(this.fb, this.eForm);
   }

   formController() {
      this.eForm = this.fb.group({
         formName: this.fb.group({th: '', en: '',cn: ''}),
         key: this.uuid.getUUIDV4,
         original: [this.formValue.original],
         sections: this.fb.array([]),
         value: this.formValue.value,
      });

      const _tmpGroup = this.eForm.controls.formName as FormGroup;
      _tmpGroup.get(this.formValue.original).setValidators(Validators.required);
   }

   createSection(index?: number) {
      if (index || index === 0) {
         this.helper.getSectionAsFormArray(this.eForm).insert(index, this.newControl.getNewSection);
      } else {
         this.helper.getSectionAsFormArray(this.eForm).push(this.newControl.getNewSection);
      }
   }

   createFields(sectionIndex?: number, fieldIndex?: number, $event?: any, fieldType?: string) {
      if (sectionIndex === -1) { return; }
      const field = this.helper.getSectionAsFormArray(this.eForm).at(sectionIndex).get('fields') as FormArray;
      if (fieldIndex >= 0 && fieldIndex !== -1) {
         switch (fieldType) {
            case 'f-textbox': field.insert(fieldIndex, this.newControl.getNewTextBox); break;
            case 'f-radio': field.insert(fieldIndex, this.newControl.getNewRadio); break;
            case 'f-choice': field.insert(fieldIndex, this.newControl.getNewChoice); break;
            case 'f-number': field.insert(fieldIndex, this.newControl.getNewNumber); break;
            case 'f-date': field.insert(fieldIndex, this.newControl.getNewDate); break;
            case 'f-email': field.insert(fieldIndex, this.newControl.getNewEmail); break;
            case 'f-website': field.insert(fieldIndex, this.newControl.getNewWebSite); break;
            case 'f-phone': field.insert(fieldIndex, this.newControl.getNewPhone); break;
            case 'f-currency': field.insert(fieldIndex, this.newControl.getNewCurrency); break;
            case 'f-address': field.insert(fieldIndex, this.newControl.getNewAddress); break;
            case 'f-signature': field.insert(fieldIndex, this.newControl.getNewSignature); break;
            case 'f-name': field.insert(fieldIndex, this.newControl.getNewName); break;
            case 'f-upload': field.insert(fieldIndex, this.newControl.getNewUpload); break;
            case 'f-table': field.insert(fieldIndex, this.newControl.getNewTable); break;
         }
      } else {
         switch (fieldType) {
            case 'f-textbox': field.push(this.newControl.getNewTextBox); break;
            case 'f-radio': field.push(this.newControl.getNewRadio); break;
            case 'f-choice': field.push(this.newControl.getNewChoice); break;
            case 'f-number': field.push(this.newControl.getNewNumber); break;
            case 'f-date': field.push(this.newControl.getNewDate); break;
            case 'f-email': field.push(this.newControl.getNewEmail); break;
            case 'f-website': field.push(this.newControl.getNewWebSite); break;
            case 'f-phone': field.push(this.newControl.getNewPhone); break;
            case 'f-currency': field.push(this.newControl.getNewCurrency); break;
            case 'f-address': field.push(this.newControl.getNewAddress); break;
            case 'f-signature': field.push(this.newControl.getNewSignature); break;
            case 'f-name': field.push(this.newControl.getNewName); break;
            case 'f-upload': field.push(this.newControl.getNewUpload); break;
            case 'f-table': field.push(this.newControl.getNewTable); break;
         }
      }
      return field;
   }

   createFieldsTable(sectionIndex?: number, fieldIndex?: number, tableIndex?: number, $event?: any, fieldType?: string) {
      const field = this.helper.getFieldAsFormArray(this.eForm, sectionIndex).at(fieldIndex).get('columns') as FormArray;

      if (tableIndex >= 0 && tableIndex !== -1) {
         switch (fieldType) {
            case 't-textbox': field.insert(tableIndex, this.newControl.getNewTableTextBox); break;
            case 't-number': field.insert(tableIndex, this.newControl.getNewTableNumber); break;
            case 't-currency': field.insert(tableIndex, this.newControl.getNewTableCurrency); break;
            case 't-date': field.insert(tableIndex,this.newControl.getNewTableDate); break;
            case 't-phone': field.insert(tableIndex,this.newControl.getNewTablePhone); break;
            case 't-email': field.insert(tableIndex,this.newControl.getNewTableEmail); break;
            case 't-website': field.insert(tableIndex,this.newControl.getNewTableWebSite); break;
            case 't-radio': field.insert(tableIndex,this.newControl.getNewTableRadio); break;
            case 't-choice': field.insert(tableIndex,this.newControl.getNewTableChoice); break;
         }
      } else {
         switch (fieldType) {
            case 't-textbox': field.push(this.newControl.getNewTableTextBox); break;
            case 't-number': field.push(this.newControl.getNewTableNumber); break;
            case 't-currency': field.push(this.newControl.getNewTableCurrency); break;
            case 't-date': field.push(this.newControl.getNewTableDate); break;
            case 't-phone': field.push(this.newControl.getNewTablePhone); break;
            case 't-email': field.push(this.newControl.getNewTableEmail); break;
            case 't-website': field.push(this.newControl.getNewTableWebSite); break;
            case 't-radio': field.push(this.newControl.getNewTableRadio); break;
            case 't-choice': field.push(this.newControl.getNewTableChoice); break;
         }
      }
      return field;
   }

   storeValue(value: any) {
      this.eForm.controls.value.setValue(value);
   }

   storeMetaField(data: MultiLang, key: string) {
      const formName = this.eForm.controls.formName as FormGroup;
      const _clearAsyncValidator = () => {
         Object.keys(formName.controls).forEach(index => formName.controls[index].clearValidators());
      };
      _clearAsyncValidator();
      this.eForm.controls.key.setValue(key);
      formName.controls.en.setValue(data.en);
      formName.controls.th.setValue(data.th);
      formName.controls.cn.setValue(data.cn);
      formName.get(this.formValue.original).setValidators(Validators.required);
   }

   storeSection(data: Array<Section>) {
      const section = this.helper.getSectionAsFormArray(this.eForm);
      data.forEach(res => {
         section.push(this.fb.group({
            name: this.fb.group ({
               th: res.name.th,
               en: res.name.en,
               cn: res.name.cn
            }),
            key: res.key,
            classes: res.classes,
            description: this.fb.group ({
               th: res.description.th,
               en: res.description.en,
               cn: res.description.cn
            }),
            permissions: this.storePermission(res.permissions),
            fields: this.storeField(res.fields),
         }));
      });
   }

   storePermission(data: Array<Group>) {
      const permissions = this.fb.array([]) as FormArray;
      data.forEach(res => {
         permissions.push(this.fb.group({
            type: res.type,
            id: res.id,
            name: res.name,
            groupCode: res.groupCode,
            siteCode: res.siteCode,
            authority: res.authority
         }));
      });
      return permissions;
   }

   storeField(data: Array<Field>) {
      const fields = this.fb.array([]) as FormArray;

      data.forEach((res, index) => {

         fields.push(this.fb.group({
            labelName: this.fb.group ({
               th: res.labelName.th,
               en: res.labelName.en,
               cn: res.labelName.cn
            }),
            key: res.key,
            display: [res.display, Validators.required],
            fieldName: [res.fieldName, [Validators.required, this.validators.fieldExisting.bind(this)]],
            fieldType: [res.fieldType, Validators.required],
            type: [res.type, Validators.required],
            required: [res.required, Validators.required],
            columns: res.columns ? this.storeFieldTable(res.columns) : [],
         }));

         const fieldGroup = fields.at(index) as FormGroup;
         if (res.placeholder) {
            fieldGroup.addControl('placeholder', this.fb.group({
               th: res.placeholder.th,
               en: res.placeholder.en,
               cn: res.placeholder.cn }));
         }

         switch (res.fieldType) {
            case 'f-textbox': this.storeTextBox(fieldGroup, res); break;
            case 'f-radio': this.storeRadio(fieldGroup, res); break;
            case 'f-choice': this.storeChoice(fieldGroup, res); break;
            case 'f-number': this.storeNumber(fieldGroup, res); break;
            case 'f-date': this.storeDateTime(fieldGroup, res); break;
            case 'f-currency': this.storeCurrency(fieldGroup, res); break;
            case 'f-address': this.storeAddress(fieldGroup, res); break;
            case 'f-signature': this.storeSignature(fieldGroup, res); break;
            case 'f-name': this.storeName(fieldGroup, res); break;
            case 'f-upload': this.storeUpload(fieldGroup, res); break;
            case 'f-table': this.storeTable(fieldGroup, res); break;
         }
      });
      return fields;
   }

   storeTable(fieldGroup: FormGroup, res: Field) {
      const _minItem = (res.minItem === undefined) ? '' : res.minItem;
      const _maxItem = (res.maxItem === undefined) ? '' : res.maxItem;
      fieldGroup.addControl('minItem', new FormControl(_minItem));
      fieldGroup.addControl('maxItem', new FormControl(_maxItem));
      fieldGroup.controls.minItem.setValidators([this.validators.checkValueItem.bind(this)]);
      fieldGroup.controls.maxItem.setValidators([this.validators.checkValueItem.bind(this)]);
   }

   storeFieldTable(data: Array<Column>) {
      const fields = this.fb.array([]) as FormArray;
      data.forEach((res, index) => {
         fields.push(this.fb.group({
            labelName: this.fb.group ({
               th: res.labelName.th,
               en: res.labelName.en,
               cn: res.labelName.cn
            }),
            key: res.key,
            display: [res.display, Validators.required],
            fieldName: [res.fieldName, [Validators.required, this.validators.fieldExistingColumn.bind(this)]],
            fieldType: [res.fieldType, Validators.required],
            type: [res.type, Validators.required],
            required: [res.required, Validators.required]
         }));

         const fieldGroup = fields.at(index) as FormGroup;
         if (res.placeholder) {
            fieldGroup.addControl('placeholder', this.fb.group({
               th: res.placeholder.th,
               en: res.placeholder.en,
               cn: res.placeholder.cn }));
         }

         switch (res.fieldType) {
            case 't-textbox': this.storeTextBoxTable(fieldGroup, res); break;
            case 't-number': this.storeNumberTable(fieldGroup, res); break;
            case 't-currency': this.storeCurrencyTable(fieldGroup, res); break;
            case 't-choice': this.storeChoiceTable(fieldGroup,res); break;
            case 't-radio': this.storeRadioTable(fieldGroup, res); break;
            case 't-date': this.storeDateTimeTable(fieldGroup, res); break;
         }
      });
      return fields;
   }

   storeDateTimeTable(fieldGroup: FormGroup, res: Column) {
      fieldGroup.addControl('separateDate', new FormControl(res.separateDate));
      fieldGroup.addControl('dateOption', new FormControl(res.dateOption));
      fieldGroup.addControl('dateFormat', new FormControl(res.dateFormat));
      fieldGroup.addControl('timeOption', new FormControl(res.timeOption));
      fieldGroup.addControl('timeFormat', new FormControl(res.timeFormat));
   }

   storeRadioTable(fieldGroup: FormGroup, res: Column) {
      fieldGroup.addControl('radioOption', new FormControl(res.radioOption));
      fieldGroup.addControl('radioDefaultValue', new FormControl(res.radioDefaultValue));
      fieldGroup.removeControl('placeholder');
   }

   storeChoice(fieldGroup: FormGroup, res: Field) {
      const lookupConvert = new LookUpConverter(this.eForm, this.fb);
      const choices = this.fb.array([]);
      let choiceTmp  = this.fb.array([]);
      const masterTableId = res.choiceLookUp.id;
      lookupConvert._prepareChoices(res.choices, choices);
      if (masterTableId) {
         this.api.getLookup(masterTableId).subscribe(lookup => {
            const _tmpObjects  = lookupConvert._filterObjects(lookup);
            lookupConvert._prepareChoices(_tmpObjects, choiceTmp);

            fieldGroup.addControl('tempLookupDefault', new FormControl(lookup.defaultValue));
         });
      } else {
         choiceTmp =  this.newControl.getInitChoice;
         fieldGroup.addControl('tempLookupDefault', new FormControl(1));
      }
      fieldGroup.removeControl('placeholder');
      fieldGroup.addControl('choiceLayout', new FormControl(res.choiceLayout));
      fieldGroup.addControl('choiceOption', new FormControl(res.choiceOption));
      fieldGroup.addControl('choiceDefaultValue', new FormControl(res.choiceDefaultValue));
      fieldGroup.addControl('choices', choices);
      fieldGroup.addControl('choiceTmp', choiceTmp);
      fieldGroup.addControl('choiceLookUp',
         this.fb.group({
            id: res.choiceLookUp.id, tableName: res.choiceLookUp.tableName,
            columnName: res.choiceLookUp.columnName, isLookUp: res.choiceLookUp.isLookUp
         }));
   }

   storeChoiceTable(fieldGroup: FormGroup, res: Column) {
      const lookupConvert = new LookUpConverter(this.eForm, this.fb);
      const choices = this.fb.array([]);
      let choiceTmp  = this.fb.array([]);
      const masterTableId = res.choiceLookUp.id;
      lookupConvert._prepareChoices(res.choices, choices);
      if (masterTableId) {
         this.api.getLookup(masterTableId).subscribe(lookup => {
            const _tmpObjects  = lookupConvert._filterObjects(lookup);
            lookupConvert._prepareChoices(_tmpObjects, choiceTmp);

            fieldGroup.addControl('tempLookupDefault', new FormControl(lookup.defaultValue));
         });
      } else {
         choiceTmp =  this.newControl.getInitChoice;
         fieldGroup.addControl('tempLookupDefault', new FormControl(1));
      }
      fieldGroup.removeControl('placeholder');
      fieldGroup.addControl('choiceLayout', new FormControl(res.choiceLayout));
      fieldGroup.addControl('choiceOption', new FormControl(res.choiceOption));
      fieldGroup.addControl('choiceDefaultValue', new FormControl(res.choiceDefaultValue));
      fieldGroup.addControl('choices', choices);
      fieldGroup.addControl('choiceTmp', choiceTmp);
      fieldGroup.addControl('choiceLookUp',
         this.fb.group({
            id: res.choiceLookUp.id, tableName: res.choiceLookUp.tableName,
            columnName: res.choiceLookUp.columnName, isLookUp: res.choiceLookUp.isLookUp
         }));
   }

   storeDateTime(fieldGroup: FormGroup, res: Field) {
      fieldGroup.addControl('separateDate', new FormControl(res.separateDate));
      fieldGroup.addControl('dateOption', new FormControl(res.dateOption));
      fieldGroup.addControl('dateFormat', new FormControl(res.dateFormat));
      fieldGroup.addControl('timeOption', new FormControl(res.timeOption));
      fieldGroup.addControl('timeFormat', new FormControl(res.timeFormat));
   }

   storeSignature(fieldGroup: FormGroup, res: Field) {
      fieldGroup.removeControl('placeholder');
      fieldGroup.addControl('includeSignature', new FormControl(res.includeSignature));
      fieldGroup.addControl('includePublicKey', new FormControl(res.includePublicKey));
   }

   storeTextBox(fieldGroup: FormGroup, res: Field) {
      fieldGroup.addControl('placeholders', new FormGroup({}));
      fieldGroup.addControl('isRegex', new FormControl(res.isRegex, Validators.required));
      fieldGroup.addControl('maxLength', new FormControl(res.maxLength, Validators.required));
      if (res.isRegex) {
         fieldGroup.addControl('regex', new FormControl(res.regex, Validators.required));
         fieldGroup.addControl('regexMessage', new FormGroup({
            'th' : new FormControl(res.regexMessage.th),
            'en' : new FormControl(res.regexMessage.en),
            'cn' : new FormControl(res.regexMessage.cn)
         }));
         const _regexMsg = fieldGroup.controls.regexMessage as FormGroup;
         _regexMsg.controls[this.eForm.controls.original.value].setValidators(Validators.required);
      }
   }

   storeTextBoxTable(fieldGroup: FormGroup, res: Column) {
      fieldGroup.addControl('placeholders', new FormGroup({}));
      fieldGroup.addControl('isRegex', new FormControl(res.isRegex, Validators.required));
      fieldGroup.addControl('maxLength', new FormControl(res.maxLength, Validators.required));
      if (res.isRegex) {
         fieldGroup.addControl('regex', new FormControl(res.regex, Validators.required));
         fieldGroup.addControl('regexMessage', new FormGroup({
            'th' : new FormControl(res.regexMessage.th),
            'en' : new FormControl(res.regexMessage.en),
            'cn' : new FormControl(res.regexMessage.cn)
         }));
         const _regexMsg = fieldGroup.controls.regexMessage as FormGroup;
         _regexMsg.controls[this.eForm.controls.original.value].setValidators(Validators.required);
      }
   }

   storeNumberTable(fieldGroup: FormGroup, res: Column) {
      const _rageStart = (res.rangeStart === undefined) ? '' : res.rangeStart;
      const _rageEnd = (res.rangeEnd === undefined) ? '' : res.rangeEnd;
      fieldGroup.addControl('placeholders', new FormGroup({}));
      fieldGroup.addControl('isRegex', new FormControl(res.isRegex, Validators.required));
      fieldGroup.addControl('decimalPlace', new FormControl(res.decimalPlace, Validators.required));
      fieldGroup.addControl('rangeStart', new FormControl(_rageStart));
      fieldGroup.addControl('rangeEnd', new FormControl(_rageEnd));
      fieldGroup.controls.rangeStart.setValidators([this.validators.fieldBadRange.bind(this),
         this.validators.fieldMustNotBeDash.bind(this)]);
      fieldGroup.controls.rangeEnd.setValidators([this.validators.fieldBadRange.bind(this),
         this.validators.fieldMustNotBeDash.bind(this)]);
      fieldGroup.addControl('typeSummary', new FormControl(res.typeSummary, Validators.required));

   }

   storeCurrencyTable(fieldGroup: FormGroup, res: Column) {
      const _rageStart = (res.rangeStart === undefined) ? '' : res.rangeStart;
      const _rageEnd = (res.rangeEnd === undefined) ? '' : res.rangeEnd;
      fieldGroup.removeControl('placeholder');
      fieldGroup.addControl('currency', new FormControl(res.currency));
      fieldGroup.addControl('subType', new FormControl(res.subType));
      fieldGroup.addControl('rangeStart', new FormControl(_rageStart));
      fieldGroup.addControl('rangeEnd', new FormControl(_rageEnd));
      fieldGroup.controls.rangeStart.setValidators([this.validators.fieldBadRange.bind(this),
         this.validators.fieldMustNotBeDash.bind(this)]);
      fieldGroup.controls.rangeEnd.setValidators([this.validators.fieldBadRange.bind(this),
         this.validators.fieldMustNotBeDash.bind(this)]);
      fieldGroup.addControl('typeSummary', new FormControl(res.typeSummary, Validators.required));
      fieldGroup.addControl('order', new FormControl(res.order));
   }

   storeRadio(fieldGroup: FormGroup, res: Field) {
      fieldGroup.addControl('radioOption', new FormControl(res.radioOption));
      fieldGroup.addControl('radioDefaultValue', new FormControl(res.radioDefaultValue));
      fieldGroup.removeControl('placeholder');
   }

   storeUpload(fieldGroup: FormGroup, res: Field) {
      fieldGroup.addControl('allowType', new FormControl(res.allowType));
      fieldGroup.addControl('maximumSize', new FormControl(res.maximumSize));
      fieldGroup.addControl('maximumFile', new FormControl(res.maximumFile));
   }

   storeCurrency(fieldGroup: FormGroup, res: Field) {
      const _rageStart = (res.rangeStart === undefined) ? '' : res.rangeStart;
      const _rageEnd = (res.rangeEnd === undefined) ? '' : res.rangeEnd;
      fieldGroup.removeControl('placeholder');
      fieldGroup.addControl('currency', new FormControl(res.currency));
      fieldGroup.addControl('subType', new FormControl(res.subType));
      fieldGroup.addControl('rangeStart', new FormControl(_rageStart));
      fieldGroup.addControl('rangeEnd', new FormControl(_rageEnd));
      fieldGroup.controls.rangeStart.setValidators([this.validators.fieldBadRange.bind(this),
         this.validators.fieldMustNotBeDash.bind(this)]);
      fieldGroup.controls.rangeEnd.setValidators([this.validators.fieldBadRange.bind(this),
         this.validators.fieldMustNotBeDash.bind(this)]);
      fieldGroup.addControl('order', new FormControl(res.order));
   }

   storeNumber(fieldGroup: FormGroup, res: Field) {
      const _rageStart = (res.rangeStart === undefined) ? '' : res.rangeStart;
      const _rageEnd = (res.rangeEnd === undefined) ? '' : res.rangeEnd;
      const _decimalPlace = (res.decimalPlace === undefined) ? '' : res.decimalPlace;
      fieldGroup.addControl('decimalPlace', new FormControl(_decimalPlace));
      fieldGroup.addControl('rangeStart', new FormControl(_rageStart));
      fieldGroup.addControl('rangeEnd', new FormControl(_rageEnd));
      fieldGroup.controls.rangeStart.setValidators([this.validators.fieldBadRange.bind(this),
      this.validators.fieldMustDecimal.bind(this),
      this.validators.fieldDecimalMath.bind(this),
      this.validators.fieldMustNotBeDash.bind(this)]);
      fieldGroup.controls.rangeEnd.setValidators([this.validators.fieldBadRange.bind(this),
      this.validators.fieldMustDecimal.bind(this),
      this.validators.fieldDecimalMath.bind(this),
      this.validators.fieldMustNotBeDash.bind(this)]);
   }

   storeAddress(fieldGroup: FormGroup, res: Field) {
      const _forDisable = ['address1', 'address2'];
      const _helpLabel = (valuel: any) => new FormGroup({'en': new FormControl(valuel.en),'cn': new FormControl(valuel.cn), 'th': new FormControl(valuel.th)});
      const _objLabel = ['labelAddress1', 'labelAddress2', 'labelProvince', 'labelDistrict', 'labelSubDistrict',
                         'labelZipcode', 'labelPostal', 'labelCity', 'labelState', 'labelCountry'];
      const _disableField = (_object) => {
         for (const index in _forDisable) {
            if (!fieldGroup.get(_forDisable[index]).get('include').value) {
               const _tmp = fieldGroup.get(_forDisable[index]) as FormGroup;
               _tmp.controls.required.disable();
               const _tmpGroup = _tmp.get('defaultValue') as FormGroup;
               if (_tmpGroup.controls === undefined) {
                  _tmpGroup.disable();
               } else {
                  _tmpGroup.controls.value.disable();
               }
            }
         }
      };
      fieldGroup.addControl('addressLabel', new FormGroup({}));
      fieldGroup.addControl('placeholders', new FormGroup({}));
      _objLabel.forEach(v => {
          const _temp = fieldGroup.get('addressLabel') as FormGroup;
          _temp.addControl(v, _helpLabel(res.addressLabel[v]));
      });

      fieldGroup.addControl('address1', new FormGroup({
         'required': new FormControl(res.address1.required),
         'include': new FormControl(res.address1.include),
         'defaultValue': this.fb.group(res.address1.defaultValue === undefined ? { value: '' } : res.address1.defaultValue)
      }));
      fieldGroup.addControl('address2', new FormGroup({
         'required': new FormControl(res.address2.required),
         'include': new FormControl(res.address2.include),
         'defaultValue': this.fb.group(res.address2.defaultValue === undefined ? { value: '' } : res.address2.defaultValue)
      }));

      if (res.type === 'local') {
         _forDisable.push('province', 'district', 'subDistrict', 'zipCode');
         fieldGroup.addControl('province', this.fb.group({
            include: res.province.include, required: res.province.required,
            defaultValue: res.province.defaultValue === undefined ?
               { code: '', name_th: '', name_en: '' , name_cn: '' } : res.province.defaultValue
         })),
            fieldGroup.addControl('district', this.fb.group({
               include: res.district.include, required: res.district.required,
               defaultValue: res.district.defaultValue === undefined ?
                  { code: '', name_th: '', name_en: '', name_cn: ''  } : res.district.defaultValue
            })),
            fieldGroup.addControl('subDistrict', this.fb.group({
               include: res.subDistrict.include, required: res.subDistrict.required,
               defaultValue: res.subDistrict.defaultValue === undefined ?
                  { code: '', name_th: '', name_en: '', name_cn: '' , zip_code: '' } : res.subDistrict.defaultValue
            })),
            fieldGroup.addControl('zipCode', this.fb.group({
               include: res.zipCode.include, required: res.zipCode.required,
               defaultValue: res.zipCode.defaultValue === undefined ?
                  { code: '', name_th: '', name_en: '', name_cn: '' , zip_code: '' } : res.zipCode.defaultValue
            }));
      } else {
         _forDisable.push('city', 'state', 'postal', 'country');
         fieldGroup.addControl('city', new FormGroup({
            'required': new FormControl(res.city.required),
            'include': new FormControl(res.city.include),
            'defaultValue': this.fb.group(res.city.defaultValue === undefined ? { value: '' } : res.city.defaultValue)
         }));
         fieldGroup.addControl('state', new FormGroup({
            'required': new FormControl(res.state.required),
            'include': new FormControl(res.state.include),
            'defaultValue': this.fb.group(res.state.defaultValue === undefined ? { value: '' } : res.state.defaultValue)
         }));
         fieldGroup.addControl('postal', new FormGroup({
            'required': new FormControl(res.postal.required),
            'include': new FormControl(res.postal.include),
            'defaultValue': this.fb.group(res.postal.defaultValue === undefined ? { value: '' } : res.postal.defaultValue)
         }));
         fieldGroup.addControl('country', this.fb.group({
            include: res.country.include, required: res.country.required,
            defaultValue: res.country.defaultValue === undefined ?
               { id: '', name_th: '', name_en: '', name_cn: ''  } : res.country.defaultValue
         }));
      }
      _disableField(_forDisable);
      fieldGroup.setValidators(this.validators.includeValidator.bind(this));
   }

   storeName(fieldGroup: FormGroup, res: Field) {
      const _helpLabel = (valuel: any) => new FormGroup({'en': new FormControl(valuel.en),'cn': new FormControl(valuel.cn), 'th': new FormControl(valuel.th)});
      const _objLabel = ['labelTitle', 'labelName', 'labelSurname', 'labelMiddle', 'labelInitial'];
      const _tmpCheck = [res.title, res.middleName, res.initial];
      fieldGroup.addControl('nameLabel', new FormGroup({}));
      fieldGroup.addControl('placeholders', new FormGroup({}));
      _objLabel.forEach(v => {
          const _temp = fieldGroup.get('nameLabel') as FormGroup;
          _temp.addControl(v, _helpLabel(res.nameLabel[v]));
      });

      const _mustType = (conditional: number) => {
         switch (conditional) {
            case 0 : return 'title';
            case 1 : return 'middleName';
            default : return 'initial';
         }
      };
      const _disableField = (_type: string) => {
         const _tmp = fieldGroup.get(_type) as FormGroup;
         _tmp.controls.required.disable();
      };
      const customizeData = this.fb.array([]) as FormArray;

      for (const [_index , _value] of _tmpCheck.entries()) {
         fieldGroup.addControl(_mustType(_index), new FormGroup({
            'required': new FormControl(res[_mustType(_index)].required),
            'include': new FormControl(res[_mustType(_index)].include),
         }));
         if (_mustType(_index) === 'title' ) {
            const _title = fieldGroup.controls.title as FormGroup;
               _title.addControl('type', new FormControl(res.title.type));
               res.title.customizeData.forEach(result => {
                  const _tmpGroup = this.fb.group({
                     id: result.id,
                     en: result.en,
                     th: result.th,
                     cn: result.cn
                  });
                  if (_title.value.type === 2 && res[_mustType(_index)].required) {
                     _tmpGroup.controls[this.formValue.original].setValidators(Validators.required);
                  }
                  customizeData.push(_tmpGroup);
               });

               _title.addControl('customizeData', customizeData);
         }
         if (!res[_mustType(_index)].include) {
            _disableField(_mustType(_index));
         }
      }
   }

   storeChoiceString(choice: number) {
      let _text = '';
      switch (choice) {
         case 0: _text = this.choiceString1; break;
         case 1: _text = this.choiceString2; break;
         case 2: _text = this.choiceString3; break;
         case 3: _text = this.choiceString4; break;
         case 4: _text = this.choiceString5; break;
         default: break;
      }
      return _text;
   }

   get selectedLanguage(): string{
      let lang = this.eForm?.controls?.original?.value;
      if (!lang) {
         lang = localStorage.getItem('lang') || 'en';
      }
      return lang;
   }

   validateZdoxOneFile(files: any, docList: any): boolean {
      const count = docList?.filter(f => f.docName?.endsWith('.zdox') || f.isForm ).length;
      const fileCount = files?.filter(f => f.name?.endsWith('.zdox')).length;
      return (count === 0 && fileCount > 1) || (fileCount > 0 && count > 0);
   }
}
